import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DrawerRegistryService {
  private readonly openCount = new BehaviorSubject<number>(0);
  readonly anyOpen$ = this.openCount.pipe(map(c => c > 0), distinctUntilChanged());

  opened(): void {
    this.openCount.next(this.openCount.value + 1);
  }

  closed(): void {
    this.openCount.next(Math.max(0, this.openCount.value - 1));
  }
}
